import React, { useState } from "react";

export default function useErrors(defaultValue = {}) {
  const [errors, setErrors] = useState(defaultValue);

  const validateErrors = (form) => {
    let newErrors = {};

    Object.entries(form).forEach(([key, value]) => {
      console.log({ key, value });
      if (!value) return (newErrors[key] = "Fill in the field");
      if (typeof value == "object") {
        newErrors[key] = {};
        Object.entries(value).forEach(([subKey, subValue]) => {
          if (!subValue) return (newErrors[key][subKey] = "Fill in the field");
          if (typeof subValue == "string" && subValue.trim() == "")
            return (newErrors[key][subKey] = "Fill in the field");
        });
      } else {
        if (typeof value == "string" && value.trim() == "")
          return (newErrors[key] = "Fill in the field");
      }
    });
    Object.entries(newErrors).forEach(([key, value]) => {
      if (typeof value == "object" && Object.keys(value).length == 0)
        delete newErrors[key];
    });
    setErrors(newErrors);
    return Object.values(newErrors).length == 0;
  };

  return { errors, setErrors, validateErrors };
}
